import React, { useEffect } from 'react';
import PageHeader from '../../components/common/PageHeader';
import { listPayments, PaymentListItem } from '../../apis/paymentApi';
import { roleNames, useSessionStore } from '../../stores';
import PaymentFilteredList from './components/PaymentFilteredList';

function PaymentList() {
  const [isLoading, setIsLoading] = React.useState(false);
  const [rows, setRows] = React.useState<PaymentListItem[]>([]);

  const currentCustomer = useSessionStore.use.currentCustomer();
  const hasRoles = useSessionStore.use.hasRoles();

  useEffect(() => {
    setRows([]);
    if (hasRoles(roleNames.billing)) {
      setIsLoading(true);
      listPayments()
        .then((items) => setRows(items))
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [currentCustomer]);

  return (
    <>
      <PageHeader title="Payments" />

      <PaymentFilteredList isLoading={isLoading} rows={rows} hasBillingRole={hasRoles(roleNames.billing)} />
    </>
  );
}

export default PaymentList;
